<template>
  <div>
    <div v-if="inited === true && (!type || type === 'ziprar' || !canView)" class="unsuport-container">
      <div v-if="canDownload" class="download">
        <span v-if="hasPassword" class="secret-info">(本文档为加密文档，下载后请联系文档上传人获取密码)</span>
        <a-button type="primary" @click="downloadPDF">下载文件</a-button>
      </div>
      <p v-if="canView" class="unsuport-hint">该文件格式预览效果较差暂不支持，请下载后查看（若无下载权限请联系上传同学）</p>
      <p v-if="!canView" class="unsuport-hint">您无权预览此文件（请联系上传同学）</p>
    </div>
    <div v-else-if="type === 'pdf'" class="pdf-container">
      <div v-if="canDownload" class="download">
        <span v-if="hasPassword" class="secret-info">(本文档为加密文档，下载后请联系文档上传人获取密码)</span>
        <a-button type="primary" @click="downloadPDF">下载PDF</a-button>
      </div>
      <a-progress v-if="progress < 100" :percent="progress" :showInfo="false" style="position:fix; z-index: 100; top: 30vh; width: 80%;" />
      <PDFViewer :url="filePath" @document-errored="onDocumentErrored"></PDFViewer>
    </div>
    <div v-else-if="type === 'excel'" style="height:100vh; background: rgb(78,92,104)">
      <div v-if="canDownload" class="download">
        <span v-if="hasPassword" class="secret-info">(本文档为加密文档，下载后请联系文档上传人获取密码)</span>
        <a-button type="primary" @click="downloadPDF">下载文件</a-button>
      </div>
      <iframe :src="filePath" width="100%" height="93%" frameborder="0" style="margin-top: 60px;"></iframe>
    </div>
    <viewer class="images" :images="images" :options="options" v-else-if="type === 'image'">
      <img v-for="src in images" :src="src" :key="src" />
    </viewer>
    <div class="player" v-else-if="type === 'video' || type === 'audio'">
      <video-player class="vjs-custom-skin" ref="videoPlayer" :options="playerOptions" :playsinline="true" @ready="playerReadied"></video-player>
    </div>
    <div class="player" v-else-if="type === 'bpVideo'">
      <video :src="bpVideoUrl" class="vjs-custom-skin" :height="playerOptions.height" controls autoplay></video>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { downloadFile } from 'assets/js/download';
import { downloadCompangy as downloadKnowledge } from '@/api/document.js';
import { fileDownload, fileView } from '@/api/document'; // collection下载

import { viewFile, downloadFile as downloadFileApi } from '@/api/common';

import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import PDFViewer from '../components/pdf/PDFViewer.vue';

import { hasPermission } from '@/utils/utils';
import store from '@/store';

export default {
  components: {
    videoPlayer,
    PDFViewer
  },
  data() {
    return {
      inited: false,
      progress: 100,
      indicator: <a-icon type="loading" style="font-size: 24px" spin />,
      origin: window.location.origin,
      baseUrl: process.env.BASE_URL,
      filePath: '',
      images: [],
      /**
       * type指的是文件名称后缀
       */
      type: this.$route.query.type,
      options: { toolbar: false },
      playerOptions: {
        height: 0.9 * document.documentElement.clientHeight,
        autoplay: false,
        muted: true,
        language: 'zh-CN',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            src: 'http://vjs.zencdn.net/v/oceans.mp4'
          }
        ]
      },
      totalPage: null,
      loadedPageCount: 0,
      canDownload: false,
      canView: false,
      loading: true,
      url: '',
      hasPassword: false,
      bpVideoUrl: ''
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    download() {
      return this.$route.query.download || false;
    },
    /**
     * documentType指的是共享文档还是项目文档还是文件收集
     * template/finish/knowledgeFile
     */
    documentType() {
      return this.$route.params.type ? this.$route.params.type : 'projectFile';
    },
    //是文件收集的页面
    isCollection() {
      return this.$route.query.taskId ? true : false;
    },
    ...mapGetters(['userInfo', 'token'])
  },
  async created() {
    if (this.$route.query.url) {
      let url = this.$route.query.url;
      this.filePath = url;
      if (this.$route.query.type === 'bpVideo') {
        this.bpVideoUrl = url;
      }
      if (this.$route.query.type === 'image') {
        this.images = [url];
      }
    } else {
      this.fileRequest();
    }
    window.addEventListener('message', event => {
      if (event.data.type === 'pdf-js-progress') {
        this.progress = event.data.progress * 100;
      }
    });
  },
  methods: {
    urlUpdated(url) {
      this.documentError = undefined;
      this.url = url;
    },
    onDocumentErrored(e) {
      this.documentError = e.text;
    },
    downloadPDF() {
      let downloadApi = this.isCollection ? fileDownload : downloadFileApi;

      let body = this.isCollection
        ? {
            type: this.$route.params.type === 'template' ? 1 : 2, // 1是模板文件,2是作业文件
            taskId: this.$route.query.taskId,
            fileId: this.$route.query.id
          }
        : {
            fileType: this.documentType,
            fileId: this.$route.query.id
          };

      downloadApi(body).then(res => {
        if (res.code === 200) {
          const downloadPath = res.data + '?Authorization=' + this.token;
          downloadFile(downloadPath);
        }
      });
    },
    async fileRequest() {
      let viewApi = this.isCollection ? fileView : viewFile;

      let body = this.isCollection
        ? {
            type: this.$route.params.type === 'template' ? 1 : 2,
            taskId: this.$route.query.taskId,
            fileId: this.$route.query.id
          }
        : {
            fileType: this.documentType,
            fileId: this.$route.query.id
          };

      const res = await viewApi(body);

      const data = res.data;
      if (this.isCollection) {
        data.canView = true;
        const { permissions: queue } = this.userInfo || {};
        data.canDownload = hasPermission(queue, '/document/fileCollection/download');
      }
      if (res.code === 200 && data.canView) {
        this.url = data.filePath + '?Authorization=' + this.token;
        this.type = data.viewType;
        this.canDownload = data.canDownload;
        this.canView = data.canView;
        this.hasPassword = data.hasPassword;
        if (this.type === 'pdf') {
          this.loading = true;
          this.filePath = this.url;
        } else if (this.type === 'excel') {
          this.filePath = `https://view.officeapps.live.com/op/embed.aspx?src=${this.url}`;
        } else if (this.type === 'image') {
          this.images = [this.url];
        } else if (this.type === 'video' || this.type == 'audio') {
          this.playerOptions.sources = [
            {
              type: this.$route.query.type,
              src: this.url
            }
          ];
        }
        this.inited = true;
      } else if (res.code === 200 && !data.canView) {
        this.type = data.viewType;
        this.canDownload = data.canDownload;
        this.canView = data.canView;
        this.inited = true;
      }
    },
    playerReadied(player) {
      // seek to 10s
      player.currentTime(10);
      // console.log('example 01: the player is readied', player)
    }
  }
};
</script>

<style lang="less">
.pdf-container {
  background-color: #606f7b;
  text-align: center;
  padding-top: 100px;
}
.unsuport-container {
  padding-top: 100px;
  background-color: #606f7b;
  text-align: center;
  height: 100%;
  .unsuport-hint {
    color: rgba(255, 255, 255);
    font-size: 30px;
  }
}
.download {
  top: 0;
  right: 0;
  position: absolute;
  z-index: 100;
  text-align: right;
  padding: 20px 100px 20px 0;
}
.loading-spin {
  position: absolute;
  z-index: 100;
  min-height: 100vh;
  background: red;
}
.images {
  text-align: center;
}
.player {
  display: flex;
  justify-content: center;
}
.video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-left: -1.5em;
  margin-top: -0.8em;
}
.secret-info {
  color: #ffffff;
  padding-right: 10px;
}
</style>
